/** localStorage key holding the user's first-party cookie-consent choice. */
export const CONSENT_STORAGE_KEY = 'cookie_consent';

/**
 * DOM id of the third-party Cookie-Script banner wrapper. On hosts where the
 * first-party banner is active, this node is hidden so the broken (never-
 * persisting) Cookie-Script banner never double-renders alongside it.
 */
export const COOKIESCRIPT_WRAPPER_ID = 'cookiescript_injected_wrapper';

/**
 * Root (`<html>`) class the banner toggles on managed hosts to activate the
 * scoped CSS rule that hides the Cookie-Script wrapper. Scoping the hide to a
 * class — rather than the bare id selector — keeps production untouched.
 */
export const COOKIESCRIPT_SUPPRESSED_CLASS = 'cookiescript-suppressed';

/**
 * Upper bound (ms) on how long the suppression observer watches for the
 * asynchronously injected Cookie-Script wrapper before disconnecting, so a
 * blocked or never-loaded GTM leaves no lingering DOM observer behind.
 */
export const COOKIESCRIPT_OBSERVE_TIMEOUT_MS = 10_000;

/** Persisted consent values. The banner hides once any of these is stored. */
export const CONSENT_VALUE = {
  ACCEPTED: 'accepted',
  DECLINED: 'declined',
} as const;

/**
 * Absolute privacy-policy URL on the marketing site. The portal SPA has no
 * /privacy-policy route, so a relative path would 404 — link out instead.
 */
export const PRIVACY_POLICY_URL = 'https://www.qodo.ai/privacy-policy/';
